/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTerminal = createReactComponent("terminal", "IconTerminal", [
  ["path", { d: "M5 7l5 5l-5 5", key: "svg-0" }],
  ["path", { d: "M12 19l7 0", key: "svg-1" }]
]);

export { IconTerminal as default };
//# sourceMappingURL=IconTerminal.js.map
